import { OmitStrict } from "@amx/ux-twoui-utils";
import React, { useState } from "react";
import { useComponentLogger } from "../../shared/logging";
import { DrawerBase, DrawerBaseProps } from "./DrawerBase/DrawerBase";

export const drawerComponentName = "Drawer";

export interface DrawerProps extends OmitStrict<DrawerBaseProps, "drawerOpen"> {
    /**
     * Whether the default state of the drawer is expanded or collapsed.
     */
    readonly defaultExpanded?: boolean;
}

export const Drawer: React.FC<DrawerProps> = ({
    defaultExpanded,
    onClickToOpen,
    onClickToClose,
    ...otherProps
}) => {
    useComponentLogger("Drawer", otherProps.buttonId);

    const [drawerOpen, setDrawerOpen] = useState(defaultExpanded);
    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };

    const onClickToOpenAndToggle = (event: React.MouseEvent<HTMLElement>) => {
        onClickToOpen?.(event);
        toggleDrawer();
    };

    const onClickToCloseAndToggle = (event: React.MouseEvent<HTMLElement>) => {
        onClickToClose?.(event);
        toggleDrawer();
    };

    return (
        <DrawerBase
            drawerOpen={drawerOpen}
            onClickToOpen={onClickToOpenAndToggle}
            onClickToClose={onClickToCloseAndToggle}
            {...otherProps}
        />
    );
};
